import React, { useState, useEffect } from "react";
import { Menu } from "antd";
import { theme } from "../../styles";
import { PlusOutlined } from "@ant-design/icons";
import AddTaxForm from "./AddTaxForm";
import EditTaxForm from "./EditTaxRate";
import { Grid, Tabel, DropDown, Button, Typography, Modal, Loading } from "../../core";
import DeleteModals from "../../components/Modals/deleteModals";
import { addTax, getTaxes, deleteTax } from "../../helper/utils/api/tax";
const Notify_Utils = require("../../helper/utils/Notification");

const { colors } = theme;

const TaxRate = () => {
  const [taxes, setTaxes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalState, setModalState] = useState({
    addModal: false,
    editModal: false,
    deleteModal: false,
  });
  const [record, setRecord] = useState({ toEdit: {}, toDelete: {} });

  useEffect(() => {
    loadTaxes();
  }, []);

  const loadTaxes = async () => {
    const companyId = localStorage.getItem("companyId");
    if (!companyId) return;
    setIsLoading(true);
    try {
      const { data } = await getTaxes(companyId);
      setTaxes(data.result || []);
    } catch (error) {
      console.log("error loading taxes", error);
    }
    setIsLoading(false);
  };

  const onCreate = async (values) => {
    try {
      await addTax(values);
      Notify_Utils.openNotificationWithIcon("success", "Tax added successfully");
      setModalState((prev) => ({ ...prev, addModal: false }));
      loadTaxes();
    } catch (error) {
      Notify_Utils.openNotificationWithIcon(
        "error",
        error?.response?.data?.message || "Failed to add tax"
      );
    }
  };

  const columns = [
    {
      title: "SR #",
      dataIndex: "SNo",
      key: "S.No",
      width: 150,
      render: (text, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "Tax Name",
      dataIndex: "tax_name",
      key: "tax_name",
      width: 150,
    },
    {
      title: "Rate in %",
      dataIndex: "tax_rate",
      key: "tax_rate",
      width: 150,
    },
    {
      title: "",
      dataIndex: "action",
      width: 150,
      render: (text, row) => (
        <DropDown
          overlay={
            <Menu>
              <Menu.Item
                onClick={() => {
                  setRecord({ toEdit: row, toDelete: {} });
                  setModalState((prev) => ({ ...prev, editModal: true }));
                }}
              >
                Edit
              </Menu.Item>
              <Menu.Item
                onClick={() => {
                  setRecord({ toEdit: {}, toDelete: row });
                  setModalState((prev) => ({ ...prev, deleteModal: true }));
                }}
              >
                Delete
              </Menu.Item>
            </Menu>
          }
        />
      ),
    },
  ];

  return (
    <Grid>
      {isLoading ? <Loading /> : null}
      <Button
        width="130px"
        height="30px"
        bg={colors.pink}
        margin="10px 0px 10px auto"
        onClick={() => setModalState((prev) => ({ ...prev, addModal: true }))}
      >
        <Typography align="center" as="h6" weight="600" color="white" noMargin>
          <PlusOutlined /> Add Tax Rate
        </Typography>
      </Button>

      <Modal
        closable={true}
        visible={modalState.addModal}
        footer={false}
        maxwidth="589px"
        onCancel={() => setModalState((prev) => ({ ...prev, addModal: false }))}
        tittle="Add Tax Rate"
      >
        <AddTaxForm onCreate={onCreate} />
      </Modal>

      {modalState.editModal ? (
        <EditTaxForm
          taxData={record.toEdit}
          onSuccess={() => {
            setModalState((prev) => ({ ...prev, editModal: false }));
            loadTaxes();
          }}
          onCancel={() => setModalState((prev) => ({ ...prev, editModal: false }))}
        />
      ) : null}

      <DeleteModals
        deleteModalsOpen={modalState.deleteModal}
        closeModal={() => setModalState((prev) => ({ ...prev, deleteModal: false }))}
        confirmDeleteHandler={async () => {
          try {
            await deleteTax(record.toDelete._id);
            Notify_Utils.openNotificationWithIcon("success", "Tax deleted");
            setModalState((prev) => ({ ...prev, deleteModal: false }));
            loadTaxes();
          } catch (error) {
            Notify_Utils.openNotificationWithIcon("error", "Failed to delete tax");
          }
        }}
      />

      <Tabel columns={columns} data={taxes} />
    </Grid>
  );
};

export default TaxRate;
